module.exports = __webpack_public_path__ + "img/bottom-gear-B-high_184x184.228fefff.png";